module.exports = __webpack_public_path__ + "static/img/intru.3ba3f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru.png
// module id = BIhJ
// module chunks = 0